import React from 'react';
import AgencyTemplate from '../components/AgencyTemplate';

const ProductionChemicals = () => {
	const agencyData = {
		title: "Production Chemicals",
		subtitle: "Petrochoice Integrated Services",
		description: "Petrochoice is agent for EVACHEM TECHNOLOGIES which is a modern and rapidly developing Russian company. We offer technological solutions for any tasks facing the oil production, refining and petrochemical industries throughout Russia and the CIS.",
		image: "/assets/evachem2.png",
		imageAlt: "EVACHEM Technologies logo",
		features: [
			{
				title: "Excellence in Each Molecule",
				description: "EVACHEM Technologies is a leading specialty chemicals manufacturer and a proud subsidiary of TATNEFT, one of Russia's largest vertically integrated energy companies with more than 80 years of industry experience.",
				icon: "bi bi-award",
				iconColor: "#0c61c0"
			},
			{
				title: "Innovative Solutions",
				description: "We specialize in delivering innovative chemical solutions for the Oil & Gas, Refining, Petrochemical, Personal Care, and Detergent industries. Our products are engineered to perform in the most challenging environments.",
				icon: "bi bi-lightbulb",
				iconColor: "#28a745"
			}
		],
		additionalSections: [
			{
				title: "Areas of Activity",
				items: [
					[
						{ icon: "bi bi-check-circle", iconColor: "#28a745", title: "Prevention of corrosion and biocorrosion of equipment" },
						{ icon: "bi bi-check-circle", iconColor: "#28a745", title: "Prevention and removal of paraffin deposits, reduction of oil solidification temperature" },
						{ icon: "bi bi-check-circle", iconColor: "#28a745", title: "Prevention and removal of inorganic salt deposits in equipment" },
						{ icon: "bi bi-check-circle", iconColor: "#28a745", title: "Absorption and utilization of mercaptans, hydrogen sulfide and oxygen" }
					],
					[
						{ icon: "bi bi-check-circle", iconColor: "#28a745", title: "Selection and production of demulsifiers" },
						{ icon: "bi bi-check-circle", iconColor: "#28a745", title: "Reagents and technologies used for the preparation and transportation of oil" },
						{ icon: "bi bi-check-circle", iconColor: "#28a745", title: "Complex reagents used in oil refining" },
						{ icon: "bi bi-check-circle", iconColor: "#28a745", title: "Pour point dispersant (PPD), water purifiers and defoamers" }
					]
				]
			},
			{
				title: "What We Do",
				content: "At EVACHEM, we combine cutting-edge R&D with industrial-scale manufacturing to offer a comprehensive portfolio of specialty chemicals, including:",
				items: [
					[
						{ icon: "bi bi-droplet-half", iconColor: "#007bff", title: "Drilling & Stimulation Chemicals", description: "emulsifiers, shale inhibitors, lubricity additives, biocides, and more" },
						{ icon: "bi bi-lightning-charge", iconColor: "#ffc107", title: "Upstream Oilfield Chemicals", description: "corrosion/scale inhibitors, wax control, deoilers, H₂S/O₂ scavengers" }
					],
					[
						{ icon: "bi bi-gear-wide-connected", iconColor: "#6c757d", title: "Refinery Chemicals", description: "corrosion protection, emulsion breakers, cold flow improvers, lubricity, defoamers" },
						{ icon: "bi bi-bezier2", iconColor: "#17a2b8", title: "Intermediates", description: "customized bases and active ingredients for inhibitors and breakers" }
					]
				]
			}
		]
	};

	return <AgencyTemplate {...agencyData} />;
};

export default ProductionChemicals;
